import React from 'react';
import {gray} from "@ant-design/colors";

function ArrowedNumber({value, strike, fxRate}) {
    const textprop = {}
    if (strike) {
        textprop.style = {textDecoration: 'line-through'}
    }

    const val = Math.round(value)
    if (!val) {
        return <span {...textprop}>0</span>
    }
    const isPositive = val > 0;
    const isNegative = val < 0;

    const result = (
        <span>
            <span className={`${isPositive ? "text-success" : isNegative ? "text-danger" : ""} me-3`}>
             {isPositive ? '↑' : isNegative ? '↓' : ''}
            </span>
            <span  {...textprop}>
                 {Math.abs(value).toCurrency(0)}
            </span>

        </span>

    )
    if (fxRate) {
        const converted = value / fxRate;
        return (
            <div className="d-col">
                <div className="d-row j-end">{result}</div>
                <div className="d-row j-end" style={{fontSize:10, color: gray[4]}}>{converted.toEuro(0)}</div>
            </div>
        )
    }
    return result
}

export default ArrowedNumber;